document.addEventListener("DOMContentLoaded", function () {

    const dataElement = document.getElementById("tarvyaVariantData");
    const container = document.getElementById("tarvyaProductDetails");

    if (!dataElement || !container) return;

    const variantData = JSON.parse(dataElement.textContent);

    function renderVariant(variantId) {

        const variant = variantData.find(v => Number(v.id) === Number(variantId));

        if (!variant) {
            container.innerHTML = "";
            return;
        }

        let html = '<table class="tarvya-table">';

        variant.fields.forEach(field => {

            if (
                field.value &&
                field.value !== "null" &&
                field.value !== "" &&
                field.value !== "0"
            ) {

                html += `
                    <tr>
                        <th>${field.label}</th>
                        <td>${field.value}</td>
                    </tr>
                `;

            }

        });

        html += "</table>";

        container.innerHTML = html;

    }

    function getCurrentVariant() {

        const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');

        if (input) {
            renderVariant(input.value);
        }

    }

    getCurrentVariant();

    document.addEventListener("change", function (e) {

        if (e.target.name === "id") {
            renderVariant(e.target.value);
        }

    });

    const observer = new MutationObserver(() => {
        getCurrentVariant();
    });

    const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');

    if (variantInput) {

        observer.observe(variantInput, {
            attributes: true,
            attributeFilter: ["value"]
        });

    }

});